export default "__VITE_ASSET__dd468c44__"